export default __webpack_public_path__ + "static/media/18.48f497a3.jpg";